<template>
    <button
        :id="id"
        :type="type"
        :class="{
            button: !iconOnly,
            'icon-button': iconOnly,
        }"
        :disabled="disabled"
    >
        <span
            v-if="icon"
            :class="['material-symbols-outlined', { icon: !iconOnly }]"
        >
            {{ icon }}
        </span>
        <span><slot v-if="!iconOnly"></slot></span>
    </button>
</template>
<script>
export default {
    name: "Bttn",
    props: {
        id: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: "button",
        },
        icon: {
            type: String,
            default: null,
        },
        iconOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
